
export const useAiNavigation = () => {
  const route = useRoute()

  const navigateWithCompanyContext = (targetRoute: string) => {
    console.log('=== AI Navigation Debug ===')
    console.log('Target Route:', targetRoute)
    console.log('Current Route:', route.fullPath)
    console.log('Current Route Params:', route.params)

    // Get current company ID from route params
    const companyId = route.params.company_public_id
    console.log('Company ID from params:', companyId)

    console.log("=== AI Navigation Debug ===\n")
    console.log("route", route)
    console.log("targetRoute", targetRoute)
    console.log("companyId", companyId)
    console.log("=== AI Navigation Debug ===\n")

    // If we're in a company context, inject the company_id into the path
    if (companyId) {
      // Remove leading slash if present
      const cleanRoute = targetRoute.replace(/^\//, '')
      
      // Special case: if route is just "company", navigate to the company home
      if (cleanRoute === 'company') {
        const newRoute = `/company/${companyId}`
        console.log('Navigating to company home:', newRoute)
        return navigateTo(newRoute)
      }
      
      // If the path doesn't start with 'company/', prepend the company context
      if (!cleanRoute.startsWith('company/')) {
        const newRoute = `/company/${companyId}/${cleanRoute}`
        console.log('Modified route:', newRoute)
        return navigateTo(newRoute)
      }
      
      // If it already starts with company/, inject the company_id after it
      const segments = cleanRoute.split('/')
      if (segments[0] === 'company') {
        segments.splice(1, 0, companyId.toString())
        const newRoute = '/' + segments.join('/')
        console.log('Modified route:', newRoute)
        return navigateTo(newRoute)
      }
    } else {
      console.log('No company context found in current route')
    }

    // If no company context, navigate normally
    console.log('Falling back to normal navigation:', targetRoute)
    return navigateTo(targetRoute)
  }

  return {
    navigateWithCompanyContext
  }
} 